export const footerBackgroundClassesDark = 'bg-site-neutrals-25';
export const footerBackgroundClassesLight = 'bg-site-neutrals-0';
export const footerBackgroundClasses = '';
export const footerInnerClasses =
  'w-full grid mdS:grid-cols-[140px_1fr] mdS:pt-[3.75rem] lgS:grid-cols-[142px_752px_1fr] lgS:pt-0 lgS:max-w-7xl lgS:after:absolute lgS:after:inset-0 lgS:after:left-[calc(50%+630px)] lgS:after:bg-site-neutrals-50 lgS:after:content-[""]';
export const footerGridMenuClasses =
  'grid-cols-1 px-10 mdS:grid-cols-3 mdS:pl-0 md:px-0 md:gap-4 md:grid-cols-[1fr_1fr_0.8fr] md:row-[1] md:col-span-2 mdL:col-span-3 lgS:row-span-3 lgS:pt-16 lgS:row-start-1 lgS:col-start-2 lgS:col-span-1';
export const footerLinksContainerClasses =
  'flex flex-col row-start-3 p-10 pt-2 mdS:row-start-2 mdS:col-start-2 mdS:p-0 md:px-0 md:row-start-2 md:col-start-2 md:col-span-2 mdL:row-start-2 mdL:col-start-2 mdL:col-span-2 lgS:row-start-4 lgS:col-start-2 lgS:col-span-1';
export const footerLegalClasses = 'mb-8 md:mb-6 lgS:mb-16 site-paragraph-xs';
export const footerLinksClasses = 'text-xs mb-6';
export const footerSubscriptionContainerClasses =
  'bg-site-neutrals-50 p-10 pb-8 w-full mdS:row-start-3 mdS:col-span-2 mdL:col-span-1 mdL:row-start-4 mdL:w-[50vw] lgS:row-start-2 lgS:col-span-1 lgS:py-14 lgS:pl-7 lgS:w-full lg:py-11 lg:pl-10 lg:pr-0';
export const footerSubsTextClasses = 'font-bold max-w-sm';
const footerSubscriptionTextClasses = 'site-paragraph-m mb-4';
export const footerSocialContainerClasses =
  'bg-site-neutrals-50 p-10 w-full mdS:row-start-5 mdS:col-span-2 md:px-10 md:pb-10 md:pt-0 mdL:col-span-4 lgS:row-start-3 lgS:row-span-2 lgS:col-span-1 lgS:pl-7 lg:pl-10';
export const footerSocialTitleClasses = 'site-paragraph-xl mb-4 font-bold';
export const footerSocialIconsClasses =
  'flex h-8 w-8 items-center justify-center transition-all duration-500 [&_svg]:fill-site-neutrals-700 [&:hover_svg]:fill-site-primary-600';
export const footerMenuListContainerClasses = [
  'mb-8 mdS:max-w-[12.25rem]',
  'mb-8 mdS:max-w-[12.25rem]',
  'mb-8 mdS:max-w-[12.25rem]',
];
export const footerMenuListClasses = 'site-paragraph-s mb-3 text-site-neutrals-900 hover:underline';
export const footerMenuListItemClasses = '';
export const footerMenuTitleClasses = 'site-paragraph-xl font-bold mb-4 lg:mb-6';
export const footerGetInContainerClasses =
  'w-full bg-site-neutrals-50 px-10 row-[5] mdS:row-start-4 mdS:col-span-2 mdL:p-10 mdL:col-span-3 lgS:row-start-1 lgS:pb-0 lgS:pt-16 lgS:pl-7 lg:pl-10 lgS:pr-0 lgS:col-span-1';
export const footerGetInTitleClasses = 'site-paragraph-xl font-bold mb-6';
export const footerGetInButtonsClasses =
  'float-left grid grid-cols-[_auto,_auto] gap-x-2 gap-y-5 mdS:[&_a:first-child]:col-start-2 [&_a:last-of-type]:col-start-1 [&_a:last-of-type]:row-start-1';
export const footerGetInTouchButtonsClasses = 'col-span-2 mdS:col-span-1';
export const footerGetInPhoneClasses =
  'flex items-center text-base col-span-2 transition-all hover:text-primary-600';
export const footerGetInPhoneIconClasses = 'mr-2 bg-site-neutrals-900';
export const footerDivider = 'hidden';
export const footerLogoClasses =
  'px-10 py-6 mdS:py-0 md:row-[1] md:float-left lgS:pt-16 lgS:row-span-3 lgS:col-start-1 lgS:row-start-1';

const footerSiteTheme = {
  footerBackgroundClassesDark,
  footerBackgroundClassesLight,
  footerBackgroundClasses,
  footerInnerClasses,
  footerGridMenuClasses,
  footerLinksContainerClasses,
  footerLinksClasses,
  footerLegalClasses,
  footerSubscriptionContainerClasses,
  footerSubsTextClasses,
  footerSubscriptionTextClasses,
  footerSocialContainerClasses,
  footerSocialTitleClasses,
  footerSocialIconsClasses,
  footerMenuListContainerClasses,
  footerMenuListClasses,
  footerMenuListItemClasses,
  footerMenuTitleClasses,
  footerGetInContainerClasses,
  footerGetInTitleClasses,
  footerGetInButtonsClasses,
  footerGetInPhoneClasses,
  footerGetInPhoneIconClasses,
  footerDivider,
  footerLogoClasses,
  footerGetInTouchButtonsClasses,
};

export default footerSiteTheme;
